import {
	FileAspectType,
	FileAspectSubType,
	FileAspectOrientationValue,
} from './constants';
import {fileAspectRuleDefaults} from './defaults';
import {FileAspectRule} from './types';

type GetFileAspectRuleParams<T extends FileAspectType> = {
	type: T;
} & ([T] extends [FileAspectType.ORIENTATION]
	? {
			subType?: FileAspectSubType.EQUAL_TO;
			value: FileAspectOrientationValue;
	  }
	: {
			subType: FileAspectSubType;
			value: number;
	  });

export const createFileAspectRule = <
	T extends FileAspectType = FileAspectType,
>({
	subType = FileAspectSubType.EQUAL_TO,
	type,
	value,
}: GetFileAspectRuleParams<T>): FileAspectRule => ({
	...fileAspectRuleDefaults,
	elementSubType1: type,
	elementSubType2: subType,
	elementValue1: value,
});

export default createFileAspectRule;
